import { useQuery } from '@tanstack/react-query';
import { Handshake } from 'lucide-react';
import { api } from '@/shared/api/cliente';
import { enDolares, enFecha, type Convenio } from './contrato';

export function AvisoDeConvenio({ clienteId }: { clienteId: number }) {
  const convenios = useQuery({
    queryKey: ['convenios', 'del-cliente', clienteId],
    queryFn: () => api.get<Convenio[]>(`/convenios/del-cliente/${clienteId}`),
  });

  if (!convenios.data || convenios.data.length === 0) {
    return null;
  }

  return (
    <div className="mt-3 space-y-2">
      {convenios.data.map((c) => (
        <div
          key={c.id}
          className={`flex flex-wrap items-center gap-x-4 gap-y-1 rounded-xl border px-3 py-2 text-[11px] uppercase ${
            c.cuotasVencidas > 0
              ? 'border-amber-300 bg-amber-50 text-amber-900'
              : 'border-marca-200 bg-marca-50 text-marca-900'
          }`}
        >
          <span className="flex items-center gap-1.5 font-bold">
            <Handshake className="size-4" aria-hidden />
            {c.situacion === 'POR_APROBAR' ? 'Convenio por aprobar' : 'En convenio de pago'}
            {c.situacion !== 'POR_APROBAR' && (
              <span className="importe font-semibold">
                {c.numero ?? `del libro Nº ${c.numeroEnElLibro ?? c.id}`}
              </span>
            )}
          </span>
          <span>
            Pendiente <b className="importe">{enDolares(c.pendiente)}</b> · {c.cuotasPendientes}{' '}
            cuotas
          </span>
          {c.cuotasVencidas > 0 && (
            <span className="font-bold">
              {c.cuotasVencidas} vencidas · <span className="importe">{enDolares(c.vencido)}</span>
            </span>
          )}
          {c.proximoVencimiento && c.proximaCuota != null && (
            <span>
              {c.cuotasVencidas > 0 ? 'La más antigua' : 'Próxima cuota'}{' '}
              <b className="importe">{enDolares(c.proximaCuota)}</b>{' '}
              {c.cuotasVencidas > 0 ? 'venció el' : 'vence el'} {enFecha(c.proximoVencimiento)}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
